import {
  type Associations,
  type DriverToTokenAssociation,
  isWebDataSuccess,
  mapWebData,
  webDataSuccess,
} from '@cobliteam/api-lib';

import type { SaveTokenAssociationSucceeded } from '../actions';
import type { DriverState } from '../reducer';

export const handleOnSaveTokenAssociation = (
  state: DriverState,
  action: SaveTokenAssociationSucceeded
): DriverState => {
  if (isWebDataSuccess(state.tokenAssociationsWebData)) {
    const {
      data: { associations },
    } = state.tokenAssociationsWebData;
    const { payload: driver } = action;

    let newAssociations: DriverToTokenAssociation[] = [];

    const associationIdentifierIndex = associations.findIndex(
      (association) =>
        association.cobliInternalId.toUpperCase() === driver.identifier
    );

    // update
    if (associationIdentifierIndex > -1) {
      associations[associationIdentifierIndex] = {
        driverId: action.payload.driverId,
        cobliInternalId: action.payload.identifier,
      };

      newAssociations = [...associations];
    }

    const associationDriverIndex = associations.findIndex(
      (association) => association.driverId === driver.driverId
    );
    const hasDriverInList = associationDriverIndex > -1;

    // insert
    if (!hasDriverInList && driver.identifier && !newAssociations.length) {
      associations.push({
        cobliInternalId: driver.identifier,
        driverId: driver.driverId,
      });

      newAssociations = [...associations];
    }

    // remove from list
    if (hasDriverInList && !driver.identifier && !newAssociations.length) {
      associations.splice(associationDriverIndex, associationDriverIndex + 1);
      newAssociations = [...associations];
    }

    return {
      ...state,
      saveTokenAssociationWebData: webDataSuccess(undefined),
      tokenAssociationsWebData: webDataSuccess({
        associations: newAssociations,
      }),
    };
  }

  return {
    ...state,
    saveTokenAssociationWebData: webDataSuccess(undefined),
    tokenAssociationsWebData: mapWebData((associations: Associations) => ({
      associations: associations.associations.map(
        (association: DriverToTokenAssociation) => {
          if (
            association.cobliInternalId.toUpperCase() ===
            action.payload.identifier
          ) {
            return {
              driverId: action.payload.driverId,
              cobliInternalId: action.payload.identifier,
            };
          }
          return association;
        }
      ),
    }))(state.tokenAssociationsWebData),
  };
};
